import React, { useEffect } from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';
import Contact from 'views/Contact';
import Index from 'views/Index';
import Simulator from 'views/Simulator';
import LegalDocument from 'views/Terms/Document';
import Terms from 'views/Terms';

const RouteTracker = () => {
  const location = useLocation();
  useEffect(() => {
    if (process.env.REACT_APP_GA_ID) {
      ReactGA.send({ hitType: 'pageview', page: location.pathname + location.search });
    }
  }, [location]);
  return null;
};

const Routes = () => (
  <>
    <RouteTracker />
    <Switch>
      <Route exact path="/" component={Index} />
      <Route exact path="/simulador" component={Simulator} />
      <Route exact path="/contato" component={Contact} />
      <Route exact path="/termos-de-uso" component={Terms} />
      <Route
        exact
        path="/termos-de-uso/cliente"
        render={() => <LegalDocument documentKey="clientTerms" />}
      />
      <Route
        exact
        path="/politica-de-privacidade/cliente"
        render={() => <LegalDocument documentKey="clientPrivacy" />}
      />
      <Route
        exact
        path="/termos-de-uso/parceiro"
        render={() => <LegalDocument documentKey="partnerTerms" />}
      />
      <Route
        exact
        path="/politica-de-privacidade/parceiro"
        render={() => <LegalDocument documentKey="partnerPrivacy" />}
      />
    </Switch>
  </>
);

export default Routes;
